/**
 * Configuração do quadro de Operação.
 *
 * Este quadro é a fonte oficial das demandas terceirizadas de Design e
 * Vídeo.
 *
 * IMPORTANTE: a LISTA de um card representa só a ETAPA OPERACIONAL em que
 * ele está (Design/Vídeo → Revisão final → Delivery Day → Agendamentos →
 * Concluído...). Um card muda de lista várias vezes ao longo do fluxo.
 * O que identifica o TIPO da demanda (Design ou Vídeo), de forma permanente
 * e independente da etapa, é a ETIQUETA do card — nunca a lista atual.
 */
export const OPERATIONS_BOARD_ID = '69e7ee051feb0ff4c601c560'

/**
 * Nomes exatos das etiquetas do quadro Operação que identificam o TIPO da
 * demanda (Design ou Vídeo), independentemente de em qual lista/etapa o
 * card esteja agora. Resolvidos DINAMICAMENTE por nome a cada carregamento
 * (comparação normalizada — ignora maiúsculas/acentos), nunca por ID fixo.
 *
 * ⚠️ Confirme estes nomes contra o quadro Operação real no Trello antes de
 * confiar nos números — foram assumidos com base na convenção já usada em
 * outros quadros deste projeto (ver README, seção "Etiquetas reconhecidas"),
 * não confirmados ao vivo.
 */
export const DESIGN_LABEL_NAME = 'Design'
export const VIDEO_LABEL_NAME = 'Vídeo'

/**
 * Nome exato do Custom Field numérico do quadro Operação que guarda a
 * quantidade de telas de um card de Design (Carrossel/Story). O ID desse
 * campo é resolvido dinamicamente pelo nome — nunca hardcode o ID.
 */
export const QTD_TELAS_FIELD_NAME = 'Qtd. telas'

/**
 * shortLinks (identificador curto e estável do Trello — o trecho
 * "XXXXXXXX" em trello.com/c/XXXXXXXX, que nunca muda mesmo que o card seja
 * renomeado ou movido) dos cards de capa/organização que existem dentro das
 * listas Design/Vídeo apenas como referência visual e NÃO são demandas
 * reais. Excluídos por ID — nunca por nome, posição ou texto do card.
 */
export const COVER_CARD_SHORT_LINKS: string[] = [
  'JvxjiUOX', // "Demandas da Flávia" — lista Design
  'draVOy2j', // "Demandas da Celine" — lista Vídeo
]
